import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AccountLedger, AccountDetail, StatementTotals, CurrentUserModel } from '../../models/account-ledger.model';
import { HttpService } from '../../services/http.service';
import { Sort } from '@angular/material/sort';
import { NgProgressService } from '../../services/ngProgress.service';
import { AuthService } from '../../services/auth.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonService } from '../../services';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-account-ledger',
  templateUrl: './account-ledger.component.html',
  styleUrls: ['./account-ledger.component.css']
})
export class AccountLedgerComponent implements OnInit {
  title = 'Account Ledger';
  setFullWindow = false;
  showPayment = false;
  loadContent = false;
  ledger: AccountLedger;
  sortedData: AccountLedger;
  className = "test";
  filterInput = '';

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public currentUserModel: CurrentUserModel;


  constructor(
    private router: Router,
    private httpService: HttpService,
    private authService: AuthService,
    private cs: CommonService,
    public ngProgress: NgProgressService,
    private activatedRouter: ActivatedRoute
  ) { }

  ngOnInit() {
    this.ngProgress.start();

    this.authService.getLoginInfo()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: CurrentUserModel) => {
          this.currentUserModel = res;
        },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        }
    );

    this.httpService.getWithNoCache<AccountLedger>('api/MyAccount/GetAccountLedger', null, (res) => {
      this.ledger = res;
      this.sortedData = res;
      this.sortedData.statementTransactions = this.sortedData.statementTransactions.slice();
      if (Number(this.ledger.statementTotals.balance) > 0) this.showPayment = true;
      this.loadContent = true;
    });
    $('.page-contents').animate({ scrollLeft: $('#levelOne').width() }, 400);
    this.ngProgress.done();
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {

    this.router.navigateByUrl('/myAccount');
  }

  downloadTransSummary = () => {
    let form = document.getElementById('downloadForm') as HTMLFormElement;
    if (!form) {
      form = document.createElement('form') as HTMLFormElement;
      form.id = 'downloadForm';
      form.action = '/ExportExcel/GetTransactionSummary';
      form.method = 'POST';
      form.enctype = 'multipart/form-data';
      document.body.appendChild(form);
    }
    // form.submit();
    $('#downloadForm').submit();
  }

  payAccountLedger(statementTotals: StatementTotals): void{
    let overDue = (this.cs.toNumber(statementTotals.overDue1) + this.cs.toNumber(statementTotals.overDue2) + this.cs.toNumber(statementTotals.overDue)).toFixed(2);
    this.router.navigate(['payment'], {
      relativeTo: this.activatedRouter.parent,
      queryParams: {
        overDue: overDue,
        current: statementTotals.current,
        total: statementTotals.balance,
        accountLedger: "accountLedger"
      },
      skipLocationChange: true
    });
  }
 
  dateFormat(date: any) {
    let day = {'1': '01', '2': '02', '3': '03', '4': '04', '5': '05', '6': '06', '7': '07', '8': '08', '9': '09'};
    let formatedDate = date.split('-');
    formatedDate[0] = day[formatedDate[0]];
    formatedDate = formatedDate.join('-');
    return formatedDate
  }

  sortData(sort: Sort) {
    const data = this.sortedData.statementTransactions.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData.statementTransactions = data;
    }
    this.sortedData.statementTransactions = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'date': return compare(this.dateFormat(a.transDate).split('/').reverse().join('/'), this.dateFormat(b.transDate).split('/').reverse().join('/'), isAsc);
        case 'type': return compare(a.transType.toLowerCase(), b.transType.toLowerCase(), isAsc);
        case 'doc': return compare(parseInt(a.transSortKey), parseInt(b.transSortKey), isAsc);
        case 'ref': return compare(parseInt(a.transReference), parseInt(b.transReference), isAsc);
        case 'yref': return compare(a.transDetails.toLowerCase(), b.transDetails.toLowerCase(), isAsc);
        case 'debited': return compare(parseInt(a.transAmount), parseInt(b.transAmount), isAsc);
        case 'credited': return compare(parseInt(a.transCredit), parseInt(b.transCredit), isAsc);
        case 'outstanding': return compare(parseInt(a.transRefBalance), parseInt(b.transRefBalance), isAsc);

        default: return 0;
      }
    });
  }

}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
